import { useWeb3React } from '@web3-react/core';
import useSWR from 'swr';
import abis from '../../config/contracts/abis';
import { fetcher } from '../../web3/utils';

const useTokenDetails = (tokenAddress: string | undefined) => {
    const { library } = useWeb3React();

    const error = !tokenAddress
        ? new Error('useTokenDetails: tokenAddress is not defined')
        : undefined;

    const { data: symbol, error: symbolError } = useSWR<string, Error>(
        library && tokenAddress ? [tokenAddress, 'symbol'] : null,
        {
            fetcher: fetcher(library, abis.erc20),
        }
    );

    const { data: decimals, error: decimalsError } = useSWR<number, Error>(
        library && tokenAddress ? [tokenAddress, 'decimals'] : null,
        {
            fetcher: fetcher(library, abis.erc20),
        }
    );

    return {
        symbol,
        decimals,
        isLoading: !symbol && !decimals && !symbolError && !decimalsError,
        error: symbolError || decimalsError || error,
    };
};

export default useTokenDetails;
